import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { first } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Config } from './config.model';

@Injectable({
	providedIn: 'root'
})
export class AppConfig {
	private readonly CONFIG_PATH = 'assets/config/json/config.json';
	private readonly DEV_CONFIG_PATH = 'assets/config/json/config.dev.json';

	private _config: Config | undefined;

	constructor(private http: HttpClient) {}

	get instance(): Config {
		return this._config;
	}

	static instance: Config;

	get(key: string): any {
		return _.get(this._config, key);
	}

	set(key: string, value: any): void {
		return _.set(this._config, key, value);
	}

	public load() {
		return new Promise<void>((resolve, reject) => {
			this.http
				.get(this.DEV_CONFIG_PATH)
				.pipe(first())
				.subscribe({
					next: (config: any) => this.setConfigFile(config, resolve),
					error: () => {
						console.warn(`Could not load file '${this.DEV_CONFIG_PATH}', falling back to '${this.CONFIG_PATH}'`);
						this.http
							.get(this.CONFIG_PATH)
							.pipe(first())
							.subscribe({
								next: (config: Config) => this.setConfigFile(config, resolve),
								error: (response: any) => {
									reject(`Could not load file '${this.CONFIG_PATH}': ${JSON.stringify(response)}`);
								}
							});
					}
				});
		});
	}


	private setConfigFile(config: Config, resolve) {
		if (environment.useProxy && config.backendUrlWithProxy) {
			config.backendUrl = config.backendUrlWithProxy;
			console.info('Using proxy for backend url: ' + config.backendUrl);
		}
		this._config = config;
		AppConfig.instance = config;
		resolve();
	}
}
